import breakpoints from 'Tokens/layout.json';

const breakpointEntries = Object.entries(breakpoints);

const layoutNames = breakpointEntries
  .map(([breakpoint]) => {
    if (breakpoint.substr(0, 3) !== 'mq-') {
      return false;
    }

    return breakpoint.replace('mq-', '');
  })
  .filter(Boolean);

// add the 'root' breakpoint
layoutNames.unshift('root');

const list = {};
const entries = breakpointEntries.map(([key, value]) => {
  const breakpoint = value.slice(1, -1);

  list[key] = breakpoint;

  return [key, breakpoint];
});

const generateHighDensityWidth = (widths, coefficient = 1.6) =>
  widths.map((width) => Math.round(width * coefficient));

export default { entries, layoutNames, list, generateHighDensityWidth };
